import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function CtaSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.2 });

  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20technology%20background%20with%20circuit%20board%20patterns%2C%20dark%20charcoal%20and%20warm%20amber%20tones%2C%20elegant%20minimal%20texture%2C%20modern%20enterprise%20aesthetic%2C%20no%20people%2C%20wide%20panoramic%20composition&width=1400&height=600&seq=cta1&orientation=landscape"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a1a]/85 via-[#1a1a1a]/75 to-[#1a1a1a]/85"></div>
      </div>

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-800 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
        style={{ transitionDuration: "800ms" }}
      >
        <span className="text-xs font-semibold tracking-widest uppercase text-white/50 mb-4 block">
          Partner with Us
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
          Ready for a Solution Tailored <br className="hidden md:block" /> to Your Business?
        </h2>
        <p className="text-white/65 text-sm md:text-base max-w-xl mx-auto mb-10 leading-relaxed">
          Our team of solutions architects will analyze your operational challenges and design a custom technology stack from our portfolio of world-class brands.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="bg-white text-[#1a1a1a] text-sm font-bold px-8 py-4 rounded-md hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            Get a Free Quote
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/solutions"
            className="border border-white/40 text-white text-sm font-medium px-8 py-4 rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse Solutions
          </Link>
        </div>
        {/* Trust indicators */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-12 text-white/50 text-xs">
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-white/70"></i> No commitment required
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-white/70"></i> Response within 24 hours
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-white/70"></i> Dedicated solutions architect
          </span>
        </div>
      </div>
    </section>
  );
}
